<template>
    <div class="row justify-content-center small_gutter">
        <div class="col-12 col-lg-4 col-xl-4" v-if="!sendError">
            <div class="summarizer_item">
                <h4 class="title">{{ trans('write/tool-privacy-policy-generator.Start Title block') }}</h4>
                <p>{{ trans('write/tool-privacy-policy-generator.Start Subtitle block') }}</p>

                <div class="form-group">
                    <div class="d-flex align-items-center justify-content-between">
                        <label for="prompt">{{ trans('write/tool-privacy-policy-generator.Start text') }}</label>
                        <span class="counter">{{ prompt ? prompt.length : 0 }}/150</span>
                    </div>
                    <textarea :placeholder="trans('write/tool-privacy-policy-generator.Start placeholder')" rows="3"
                              cols="100"
                              maxlength="150"
                              id="prompt"
                              v-model="prompt"
                              :class="{'is-invalid': $v.prompt.$error}"
                              class="form-control">
                    </textarea>
                    <div class="invalid-feedback" v-show="$v.prompt.$error">
                        <span v-if="!$v.prompt.requiredUnless || !$v.prompt.minLength">{{
                                trans('write/tool-main-write.Empty with min error', {min: 5})
                            }}</span>
                        <!--                        <span v-if="!$v.prompt.checkLangPrompt">{{ trans('write/tool-main-write.Lang error') }}</span>-->
                    </div>
                </div>

                <div class="form-group">
                    <div class="d-flex align-items-center justify-content-between">
                        <label for="target">{{ trans('write/tool-privacy-policy-generator.Address text') }}</label>
                        <span class="counter">{{ prompt ? prompt.length : 0 }}/500</span>
                    </div>
                    <textarea :placeholder="trans('write/tool-privacy-policy-generator.Address placeholder')" rows="5"
                              cols="100"
                              maxlength="150"
                              id="target"
                              v-model="target"
                              :class="{'is-invalid': $v.target.$error}"
                              class="form-control">
                    </textarea>
                    <div class="invalid-feedback" v-show="$v.target.$error">
                        <span v-if="!$v.target.requiredUnless || !$v.target.minLength">{{
                                trans('write/tool-main-write.Empty with min error', {min: 5})
                            }}</span>
                        <!--                        <span v-if="!$v.prompt.checkLangPrompt">{{ trans('write/tool-main-write.Lang error') }}</span>-->
                    </div>
                </div>

                <div class="form-group">
                    <div class="d-flex align-items-center justify-content-between">
                        <label for="url">{{ trans('write/tool-privacy-policy-generator.Website Url Title') }}</label>
                    </div>
                    <input type="text"
                           :placeholder="trans('write/tool-privacy-policy-generator.Website Url placeholder')"
                           :class="{'is-invalid': $v.url.$error}"
                           maxlength="400"
                           id="url" v-model="url"
                           class="form-control"/>
                    <div class="invalid-feedback" v-show="$v.url.$error">
                        <span v-if="!$v.url.required || !$v.url.minLength">{{
                                trans('write/tool-main-write.Empty with min error', {min: 5})
                            }}</span>
                        <span v-if="$v.url.minLength && !$v.url.url">{{
                                trans('write/tool-privacy-policy-generator.Website Url Invalid error')
                            }}</span>
                    </div>
                </div>

                <div class="summarizer_action">
                    <button class="button" @click="sendTextTask()"
                            :disabled="sended && !completed || subTaskInProgress"
                    >
                        <span v-if="sended && !completed"
                              class="spinner-border spinner-border-sm mr-1" role="status"
                              aria-hidden="true"></span>
                        {{ trans('write/tool-privacy-policy-generator.Generate btn') }}
                    </button>

                    <!--                    <button class="button button-outline button-update">-->
                    <!--                        <svg class="img-fluid">-->
                    <!--                            <use xlink:href="/v3/img/svg-sprite.svg#update"></use>-->
                    <!--                        </svg>-->
                    <!--                    </button>-->
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-8 col-xl-8" v-if="!sendError">

            <div class="summarizer_item" :class="{'is-disabled': !sended || sendError || !completed}">

                <div class="summarizer_item-header">
                    <div>
                        <h4 class="title">{{ trans('write/tool-main-write.Result Title block') }}</h4>
                        <p>{{ trans('write/tool-main-write.Result Subtitle block') }}</p>
                    </div>
                    <button
                        v-if="isLoggedIn"
                        class="button button-outline button-history" @click="showHistory">
                        <svg width="16" height="16">
                            <use xlink:href="/v3/img/svg-sprite.svg#clock"></use>
                        </svg>
                        {{ trans('write/tool-main-write.History label') }}
                    </button>
                </div>

                <div class="form-group">
                    <summernote
                        :disabled="!sended || sendError || !completed"
                        :placeholder="trans('write/tool-privacy-policy-generator.Result placeholder')"
                        v-model="resultText"
                        :toolbar="toolbarSimple"
                        :height="380"
                        :rewrite-callback="rewriteText"
                        :keep-write-callback="keepWriteText"
                        @onChange="onChangeResultText"
                    />
                </div>

                <div class="summarizer_action">
                    <div class="summarizer_action-item" v-if="!taskId || !completed">
                        <button class="button compress-result_button-download"
                                type="button" data-toggle="modal" data-target="#modal-result-download"
                        >{{ trans('tool-fileuploader.Download btn') }}
                        </button>
                    </div>
                    <div class="summarizer_action-item" v-else>
                        <button v-if="resultTextChanged"
                                class="button"
                                type="button" @click="sendFileContent"
                        >{{ trans('tool-fileuploader.Download btn') }}
                        </button>
                        <upload-block
                            v-else
                            type-block="new-compact"
                            :downloadUrl="downloadUrl"
                            :dropboxFiles="dropboxFiles"
                            :downloadFileInfo="downloadFileInfo"
                            @onCancelDropbox="onCancelDropbox"
                            @onErrorDropbox="onErrorDropbox"
                            @onProgressDropbox="onProgressDropbox"
                            @onSavedDropbox="onSavedDropbox"
                            @markAsDownloaded="markAsDownloaded"
                            ref="uploadBlock"/>
                    </div>

                    <rating-block
                        :type="loaderType"
                        :mode="loaderMode"
                        :task-id="taskId"
                    ></rating-block>

                    <button class="button button-grey button-copy" @click="copyResult">
                        <svg class="img-fluid">
                            <use xlink:href="/v3/img/svg-sprite.svg#copy"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="col-12 mt_25" v-if="sended && completed && !sendError">
            <div class="summarizer_item">
                <div class="component-sended--wrapper compress-result">
                    <div class="row align-items-stretch small_gutter">
                        <div class="col-lg-4 mt_25 mt-lg-0">
                            <qr-block :url="downloadUrl"
                                      :task-id="taskId"
                                      :type="loaderType"
                                      :mode="loaderMode"
                            ></qr-block>
                        </div>

                        <div class="col-lg-8 mt_25 mt-lg-0">
                            <subscribe-block></subscribe-block>
                            <share-icons-block></share-icons-block>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-10" v-if="sended && sendError">
            <div class="uploader-container">
                <div class="component-sended--wrapper compress-result">
                    <div class="row row-min-height align-items-center">
                        <div class="col-12 text-center" v-show="sendError">
                            <h5 class="mb-4" v-html="sendError"></h5>
                            <button class="btn btn-secondary" @click="cancelSendTask()">
                                {{ trans('tool-main.Back') }}
                            </button>
                            <button class="btn btn-outline-secondary ml-3" @click="reset()">
                                {{ trans('tool-main.Start Over') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <history-modal v-if="isLoggedIn"
                       :loader-mode="loaderMode"
                       :show-history-modal="showHistoryModal"
                       @showingModal="showHistoryModal = !showHistoryModal"
        ></history-modal>

    </div>
</template>

<script>
import markAsDownloaded from '../mixins/mark-as-downloaded.js';
import baseProcessing from '../mixins/base-processing.js';
import Clipboard from 'v-clipboard'
import {validationMixin} from "vuelidate";
import {required, minLength, url} from "vuelidate/lib/validators";
import writeCustomButtons from "../mixins/write-custom-buttons";
import writeSaveResult from "../mixins/write-save-result";
import autoDownload from "../mixins/auto-download";

Vue.use(Clipboard)

export default {
    props : [
        'loaderMode',
    ],
    mixins: [
        markAsDownloaded,
        baseProcessing,
        writeCustomButtons,
        writeSaveResult,
        autoDownload,
        validationMixin,
    ],
    validations() {
        return {
            prompt: {
                required,
                minLength: minLength(5),
                // checkLangPrompt: helpers.regex('prompt', /^[a-zA-Z0-9\s,.]*$/)
            },
            url   : {
                required,
                minLength: minLength(5),
                url,
            },
            target: {
                required,
                minLength: minLength(5),
            },
        }
    },
    components: {
        'share-icons-block': () => import(/* webpackChunkName: 'result-blocks' */ '../shared/ShareIconsBlock'),
        'subscribe-block'  : () => import(/* webpackChunkName: 'result-blocks' */ '../shared/SubscribeBlock'),
        'other-tools-block': () => import(/* webpackChunkName: 'result-blocks' */ '../shared/OtherToolsBlock'),
        'upload-block'     : () => import(/* webpackChunkName: 'uploadBlock' */ '../uploader/UploadBlock.vue'),
        'qr-block'         : () => import(/* webpackChunkName: 'qr-block' */ '../shared/QrBlock.vue'),
        'rating-block'     : () => import(/* webpackChunkName: 'rating-block' */ '../shared/RatingBlock.vue'),
        'history-modal'    : () => import(/* webpackChunkName: 'history-modal' */ './elements/HistoryModal.vue'),
        'summernote'       : () => import(/* webpackChunkName: 'summernote' */ '../shared/summernote/Summernote.vue'),
    },
    data() {
        let options    = [],
            strOptions = trans('write/tool-privacy-policy-generator.Length options');
        if (strOptions && strOptions.length) {
            options = strOptions.split(',');
        }
        return {
            loaderType      : 'write',
            prompt          : '',
            url             : '',
            target          : '',
            resultText      : '',
            lengthOptions   : options,
            showHistoryModal: false,
        }
    },
    computed: {
        isLoggedIn: function () {
            return window.loggedIn;
        }
    },
    methods : {
        showHistory() {
            this.showHistoryModal = true;
        },

        sendTextTask() {
            this.resultText = '';
            this.sended = false;
            this.completed = false;

            this.$v.$touch();
            if (!this.$v.$invalid) {
                Vue.nextTick(() => this.sendTask());
            }
        },

        prepareTaskData() {
            this.taskUrl = '/write/prepare';

            return {
                prompt: this.prompt,
                url   : this.url,
                target: this.target,
                mode  : this.loaderMode,
            };
        },

        afterReset() {
            this.prompt = '';
            this.url = '';
            this.target = '';
            this.resultText = '';
        },

        copyResult() {
            this.$clipboard(this.resultText);

            this.markAsDownloaded();
        },

        onBeforeSuccessProcessing(response) {
            let result = response.data;
            this.state = result.state;

            if (this.state === 'completed') {
                this.resultText = '<p>' + result.text.replaceAll("\n\n", "</p><p>").replaceAll("\n", "<br>") + '</p>';
                this.$nextTick(() => {
                    this.onChangeResultText(false);
                });
            }
        },

        async checkSelected() {
            let content = await this.getSelectedFileContent();

            if (content !== false) {
                this.prompt = content;
            }
        },
    },
    mounted() {
        this.checkSelected();
    }
}
</script>
